export default __webpack_public_path__ + "static/media/Evan.fb033275.png";